import { find, map, orderBy } from 'lodash';
import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	const sortedData: PropertyType = {};
	Object.keys(data).map((key: string) => {
		if (key === 'games') {
			const mapped = map(data[key], (item) => {
				const provider = find(data.providers, ['value', item.provider_id]);
				return {
					...item,
					label: `${provider?.label} - ${item.label}`,
					isChecked: false,
				};
			});
			sortedData[key] = orderBy(mapped, [(filter) => filter.label.toLowerCase()]);
		} else {
			const mapped = map(data[key], (item) => ({
				...item,
				isChecked: false,
			}));

			sortedData[key] = orderBy(mapped, [(filter) => filter.label.toLowerCase()]);
		}
	});

	return {
		data: sortedData,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	filterNames: data.filters,
});
